
export class EventObj<T extends Event> {
    public Event: T;
    public Handled: boolean

    constructor(event: T, startValue: boolean = false) {
        this.Event = event;
        this.Handled = startValue;
    }
}